// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3c2Oo","item":"PaymentsMobile_item__1CARc","label":"PaymentsMobile_label__1uNyb","amount":"PaymentsMobile_amount__xMZW3"};